module.exports = __webpack_public_path__ + "390eebd2e917fdc16c6a7444d5aff2f5.png";